import { render, staticRenderFns } from "./returnAndExchange.vue?vue&type=template&id=3c8ae843&scoped=true&"
import script from "./returnAndExchange.vue?vue&type=script&lang=js&"
export * from "./returnAndExchange.vue?vue&type=script&lang=js&"
import style0 from "./returnAndExchange.vue?vue&type=style&index=0&id=3c8ae843&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8ae843",
  null
  
)

export default component.exports